import { useCallback, useLayoutEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';

export const PMWorkbookEditTextField = ({ id, field, value, hasFocus }) => {
  const [valueState, setValueState] = useState(value);
  const [inputRef, setInputRef] = useState(null);
  const apiRef = useGridApiContext();

  useLayoutEffect(() => {
    if (hasFocus && inputRef) {
      const len = inputRef.value?.length ?? 0;
      inputRef.focus();
      inputRef.setSelectionRange(len, len);
    }
  }, [hasFocus, inputRef]);

  const handleChange = useCallback(
    event => {
      const newValue = event.target.value;
      setValueState(newValue);
      apiRef.current.setEditCellValue({ id, field, value: newValue, debounceMs: 200 }, event);
    },
    [apiRef, field, id]
  );

  const handleKeydown = useCallback(
    event => {
      if ((event.altKey || event.metaKey) && event.key === 'Enter') {
        event.preventDefault();
        const target = event.target;
        const start = target.selectionStart;
        const end = target.selectionEnd;
        target.value = target.value.substring(0, start) + '\n' + target.value.substring(end);
        target.setSelectionRange(start + 1, start + 1);
        handleChange(event);
      }
    },
    [handleChange]
  );

  return (
    <TextField
      data-testid={`${field}-edit-textfield`}
      multiline
      value={valueState || ''}
      sx={{ width: '100%', padding: '0 5px' }}
      onChange={handleChange}
      inputRef={ref => setInputRef(ref)}
      variant="standard"
      onKeyDown={handleKeydown}
    />
  );
};
